@if (offers) {
    <div checkoutCy="mixed_cart_choices" class="row">
        <div class="rows">
            <div class="row">
                <checkout-select-choice
                    [cartForm]="cartForm"
                    [defaultValue]="defaultValue"
                    [isMobile]="isMobile"
                    (onChoice)="onChoice($event)"
                    [mobileBloc]="true"
                    [isCompatiblePromoFoyer]="isCompatiblePromoFoyer"
                    [isFaiPureFiber]="isByou"
                />
            </div>
            @if (cartForm.get('mixed-choice')?.get('choiceControl').value === true) {
                <div class="row">
                    <div checkoutCy="multiple-card-bloc" class="columns is-multiline is-aligned-end">
                        @for (plan of offers; track trackByPrice($index, plan)) {
                            @if (isByou) {
                                <checkout-card-offer-container-byou
                                    [plan]="plan"
                                    [quoteIndex]="quoteIndex"
                                    [isLoading]="isLoading"
                                    [cartForm]="cartForm"
                                    [selectPlanEvent]="selectPlanEvent"
                                    [atLeastOneOfferHasPromoHome]="atLeastOneOfferHasPromoHome"
                                    [atLeastOneBlockablePlan]="atLeastOneBlockablePlan"
                                    class="column is-12-mobile is-4-widescreen is-6-tablet"
                                />
                            } @else {
                                <checkout-card-offer-container
                                    [plan]="plan"
                                    [quoteIndex]="quoteIndex"
                                    [isLoading]="isLoading"
                                    [cartForm]="cartForm"
                                    [selectPlanEvent]="selectPlanEvent"
                                    [atLeastOneOfferHasPromoHome]="atLeastOneOfferHasPromoHome"
                                    [atLeastOneBlockablePlan]="atLeastOneBlockablePlan"
                                    class="column is-12-mobile is-4-widescreen is-6-tablet"
                                />
                            }
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
